__turbopack_context__.v({
  "article": "EncyclopediaArticle-module-scss-module__wvFqHW__article",
  "breadcrumbs": "EncyclopediaArticle-module-scss-module__wvFqHW__breadcrumbs",
});
